import { render, staticRenderFns } from "./TS-results.vue?vue&type=template&id=aed63ab4"
import script from "./TS-results.vue?vue&type=script&lang=js"
export * from "./TS-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports